function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "utility/undo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    d: "M7.97 17L2 11M2 11L7.97 5M2 11C2 11 6.62139 11 13 11C17 11 21 12 22 16.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
SvgUndo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgUndo"
};
export default SvgUndo;